import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Menu,
  MenuItem,
  Typography,
  Box,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  useTheme,

  //Divider,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  alpha,
  TableFooter,
  Skeleton,
} from '@mui/material';
import {
  Edit as EditIcon,
  Receipt as ReceiptIcon,
  MoreVert as MoreVertIcon,
  Payment as PaymentIcon,
  //Download as DownloadIcon,
  Visibility as VisibilityIcon,
  Cancel as CancelIcon,
  Sync as SyncIcon,
  Print as PrintIcon,
  ReceiptLong as ReceiptLongIcon,
  SwapHoriz as RenegociarIcon,
  PriorityHigh as PriorityHighIcon,
  Send as SendIcon
} from '@mui/icons-material';
import { Invoice } from '../types';
import invoiceService from '../services/invoiceService';

interface GatewayNfcom {
  id: number;
  titulo: string;
  tipo: 'nuvemfiscal' | 'vigonfcom';
  ambiente: 'producao' | 'homologacao';
  is_default: boolean;
}
//import paymentService from '../services/paymentService';
import InvoiceEditForm from './forms/InvoiceEditForm';
//import PaymentForm from './forms/InvoicePaymentForm';
import ProcessBoletoModal from './modals/ProcessBoletoModal';
import { useInvoiceActions } from '../hooks/useInvoiceActions';
import EmitirNfcomModal from './modals/EmitirNfcomModal';
import { InvoiceFormData } from '../services/invoiceService';
import InvoiceViewModal from './modals/InvoiceViewModal';
import ReciboModal from './modals/ReciboModal';
import EnviarInvoiceModal from './modals/EnviarInvoiceModal';
import Swal from 'sweetalert2';
import { InvoiceStatusChip } from '../utils/faturaStatusUtils';
import { useRelatorioCores } from '../pages/relatorios/relatorioUtils';
import { formatarData, formatarDataHora, formatarValor } from '../utils/formatToView';
import api from '../services/api';
import GerenciarCobrancaModal from '../pages/financeiro/components/GerenciarCobrancaModal';

interface InvoicesTableProps {
  invoices: Invoice[];
  error?: string | null;
  loading?: boolean;
  showContractColumn?: boolean;
  showClientColumn?: boolean;
  showGatewayColumn?: boolean;
  // Funções específicas que podem ser customizadas pelas páginas
  //onEditInvoice?: (invoice: Invoice) => void;
  onReceivePayment?: (invoice: Invoice) => void;
  // Callbacks para notificar a página sobre mudanças
  onInvoiceUpdated?: () => void;
  showAlert?: (type: 'success' | 'error', message: string) => void;
  // Props para ações em massa
  //bulkCancelMode?: boolean;
  //bulkPrintMode?: boolean;
  //bulkEditMode?: boolean;
  //onBulkCancelMode?: () => void;
  //onCancelBulkMode?: () => void;
  onSelectInvoice?: (invoiceId: number, selected: boolean) => void;
  onRenegociar?: (invoiceIds: number[]) => void;
  //onBulkCancel?: () => Promise<void>;
  //onBulkPrint?: () => Promise<void>;
  selectedInvoices?: number[];
  selectionMode?: 'default' | 'delete_cancelled';
}

const InvoicesTable: React.FC<InvoicesTableProps> = ({
  invoices,
  error,
  loading,
  showContractColumn = false,
  showClientColumn = false,
  showGatewayColumn = false,
  //onEditInvoice,
  onReceivePayment,
  onInvoiceUpdated,
  showAlert,
  //bulkCancelMode = false,
  //bulkPrintMode = false,
  //bulkEditMode = false,
  //onBulkCancelMode,
  //onCancelBulkMode,
  onSelectInvoice,
  onRenegociar,
  //onBulkCancel,
  //onBulkPrint,
  selectedInvoices = [],
  selectionMode = 'default',
}) => {
  const theme = useTheme();
  const cores = useRelatorioCores();
  const faturasColor = cores.primario; // Usando a mesma cor base que a tabela de clientes (primário)


  const navigate = useNavigate();

  // Estados para edição de fatura
  const [editFormOpen, setEditFormOpen] = useState(false);
  const [selectedInvoiceForEdit, setSelectedInvoiceForEdit] = useState<Invoice | null>(null);
  // const [editLoading, setEditLoading] = useState(false);
  // const [editErrors, setEditErrors] = useState<string[]>([]);

  // Estados existentes
  //const [anchorEl, setAnchorEl] = useState<{ [key: number]: HTMLElement | null }>({});
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice | null>(null);
  //const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [processBoletoOpen, setProcessBoletoOpen] = useState(false);
  //const [invoiceViewOpen, setInvoiceViewOpen] = useState(false);
  //const [selectedInvoiceForView, setSelectedInvoiceForView] = useState<Invoice | null>(null);

  // Estados para impressão
  const [selectedInvoiceForPrint, setSelectedInvoiceForPrint] = useState<Invoice | null>(null);
  const [singlePrintInvoice, setSinglePrintInvoice] = useState<Invoice | null>(null);

  // Estados para emissão NFCom
  const [emitirNfcomOpen, setEmitirNfcomOpen] = useState(false);
  const [selectedInvoiceForNfcom, setSelectedInvoiceForNfcom] = useState<Invoice | null>(null);

  // Estados para recibo
  const [reciboOpen, setReciboOpen] = useState(false);
  const [selectedInvoiceForRecibo, setSelectedInvoiceForRecibo] = useState<number | null>(null);

  const [anchorEls, setAnchorEls] = useState<{ [key: number]: HTMLElement | null }>({});

  // Estados para gerenciar cobrança (via ícone de exclamação)
  const [gerenciarCobrancaOpen, setGerenciarCobrancaOpen] = useState(false);
  const [selectedCobrancaIdForModal, setSelectedCobrancaIdForModal] = useState<number | null>(null);

  // Estados para Modal de Ações
  const [actionsModalOpen, setActionsModalOpen] = useState(false);
  const [invoiceForActions, setInvoiceForActions] = useState<Invoice | null>(null);

  const handleOpenActionsModal = (invoice: Invoice) => {
    setInvoiceForActions(invoice);
    setActionsModalOpen(true);
  };

  const handleCloseActionsModal = () => {
    setActionsModalOpen(false);
    setInvoiceForActions(null);
  };

  // Estados para Modal de Enviar Fatura
  const [enviarModalOpen, setEnviarModalOpen] = useState(false);
  const [invoiceForEnviar, setInvoiceForEnviar] = useState<Invoice | null>(null);

  const handleEnviarClick = (invoice: Invoice) => {
    setInvoiceForEnviar(invoice);
    setEnviarModalOpen(true);
  };

  const handleEnviarClose = () => {
    setEnviarModalOpen(false);
    setInvoiceForEnviar(null);
  };

  // Funções de alerta e reload padrão caso não sejam fornecidas
  const defaultShowAlert = (type: 'success' | 'error', message: string) => {
    console.log(`[${type.toUpperCase()}] ${message}`);
  };

  const defaultLoadInvoices = async () => {
    if (onInvoiceUpdated) {
      onInvoiceUpdated();
    }
  };


  // Abrir modal de emissão NFCom
  const handleEmitirNfcomClick = async (invoice: Invoice) => {
    setSelectedInvoiceForNfcom(invoice);
    setEmitirNfcomOpen(true);
  };

  // Fechar modal de emissão NFCom
  const handleEmitirNfcomClose = () => {
    setEmitirNfcomOpen(false);
    setSelectedInvoiceForNfcom(null);
  };

  // A emissão agora é feita dentro do modal EmitirNfcomModal

  // Abrir modal de recibo
  const handleReciboClick = (invoice: Invoice) => {
    setSelectedInvoiceForRecibo(invoice.id);
    setReciboOpen(true);
  };

  // Fechar modal de recibo
  const handleReciboClose = () => {
    setReciboOpen(false);
    setSelectedInvoiceForRecibo(null);
  };

  // Hook centralizado para ações das faturas
  const {
    viewModalOpen,
    viewInvoice,
    //formOpen,
    selectedInvoice: selectedInvoiceFromHook,
    handleViewInvoice,
    handleCloseViewModal,
    //handleEditInvoice: handleEditInvoiceFromHook,
    //handleEditInvoice,
    //handleEditFromView,
    handleMassCancel,
    handleCheckGatewayStatus,
    handleProcessBoleto,
    handleMassPrint,
    //setFormOpen,
    setSelectedInvoice: setSelectedInvoiceFromHook,
  } = useInvoiceActions({
    showAlert: showAlert || defaultShowAlert,
    loadInvoices: defaultLoadInvoices
  });

  // Handlers para combinar a lógica do hook com as props customizadas
  const handleEditClick = (invoice: Invoice) => {
    setSelectedInvoiceForEdit(invoice);
    setEditFormOpen(true);
    handleCloseViewModal();
  };

  const handleEditClose = () => {
    setEditFormOpen(false);
    setSelectedInvoiceForEdit(null);
    //setEditErrors([]);
  };

  const handleEditSave = async (invoiceData: InvoiceFormData) => {
    if (!selectedInvoiceForEdit) return;

    //setEditLoading(true);
    //setEditErrors([]);

    try {
      const response = await invoiceService.updateInvoice(selectedInvoiceForEdit.id, invoiceData);

      if (response.success) {
        if (showAlert) {
          showAlert('success', 'Fatura atualizada com sucesso!');
        }
        handleEditClose();

        // Notificar componente pai sobre a atualização
        if (onInvoiceUpdated) {
          onInvoiceUpdated();
        }
      } else {
        //setEditErrors([response.message || 'Erro ao atualizar fatura']);
      }
    } catch (error: any) {
      console.error('Erro ao atualizar fatura:', error);
      //setEditErrors([error.message || 'Erro ao atualizar fatura']);
    } finally {
      //setEditLoading(false);
    }
  };

  const handleReceivePaymentClick = (invoice: Invoice) => {
    if (onReceivePayment) {
      onReceivePayment(invoice);
    } else {
      // Usar lógica padrão do hook se não houver prop customizada
      console.log('Receber pagamento - implementação padrão não disponível');
    }
  };

  const handlePaymentFromView = (invoice: Invoice) => {
    handleCloseViewModal();
    handleReceivePaymentClick(invoice);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, invoiceId: number) => {
    setAnchorEls(prev => ({ ...prev, [invoiceId]: event.currentTarget }));
  };

  const handleMenuClose = (invoiceId: number) => {
    setAnchorEls(prev => ({ ...prev, [invoiceId]: null }));
  };

  const handleProcessBoletoClick = (invoice: Invoice) => {
    setSelectedInvoice(invoice);
    setProcessBoletoOpen(true);
  };

  const handleProcessBoletoClose = () => {
    setProcessBoletoOpen(false);
    setSelectedInvoice(null);
  };

  const handleImprimirFaturaClose = () => {
    setSelectedInvoiceForPrint(null);
  };

  const handleImprimirCarneClose = () => {
    setSinglePrintInvoice(null);
  };

  /*const handlePrintSingleInvoice = (invoice: Invoice) => {
    setSelectedInvoiceForPrint(invoice);
    setImprimirFaturaOpen(true);
  };*/

  const handlePrintSingleInvoiceWithSweet = async (invoice: Invoice) => {
    setSinglePrintInvoice(invoice);

    try {
      const printType = await handleMassPrint();

      if (printType === 'fatura' || printType === 'carne' || printType === 'capa_carne') {
        // Mostrar alert de carregamento
        Swal.fire({
          title: 'Gerando PDF...',
          text: 'Aguarde enquanto geramos o documento',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const blob = await invoiceService.imprimirPDF([invoice.id], printType as 'fatura' | 'carne' | 'capa_carne');
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        Swal.close();
      }
      // Se printType for 'cancel' ou undefined, não fazer nada
    } catch (error) {
      console.error('Erro ao processar impressão individual:', error);
      if (showAlert) {
        showAlert('error', 'Erro ao gerar PDF da fatura');
      }
      Swal.close();
    }
  };

  /*const handleBulkPrintClick = async () => {
    try {
      const printType = await handleMassPrint();
      
      if (printType === 'fatura') {
        // Abrir modal de impressão de faturas
        if (selectedInvoices.length > 0) {
          setImprimirFaturaOpen(true);
        }
      } else if (printType === 'carne') {
        // Abrir modal de impressão de boletos
        if (selectedInvoices.length > 0) {
          setImprimirCarneOpen(true);
        }
      }
      // Se printType for 'cancel' ou undefined, não fazer nada
    } catch (error) {
      console.error('Erro ao processar impressão em massa:', error);
    }
  };*/





  const calculateTotal = (invoice: Invoice) => {
    const valor = Number(invoice.valor) || 0;
    const acrescimo = Number(invoice.acrescimo) || 0;
    const desconto = Number(invoice.desconto) || 0;

    return invoiceService.calculateTotal(valor, acrescimo, desconto);
  };



  const canProcessBoleto = (invoice: Invoice) => {
    const today = new Date();
    // Corrigido para considerar corretamente a data de vencimento sem subtrair um dia
    const dueDate = new Date(invoice.data_vencimento + 'T23:59:59');
    return invoice.status === 'aberto' && dueDate >= today;
  };

  const totalValorPagina = invoices.reduce((acc, f) => acc + (Number(f.valor) || 0), 0);
  const totalPagoPagina = invoices.reduce((acc, f) => acc + (Number((f as any).valor_pago) || 0), 0);

  const isInvoiceSelectable = (invoice: Invoice) => {
    if (selectionMode === 'delete_cancelled') {
      return invoice.status === 'cancelado';
    }
    return invoice.status !== 'pago' && invoice.status !== 'cancelado';
  };

  const selectableInvoices = invoices.filter(isInvoiceSelectable);
  const allSelectableSelected = selectableInvoices.length > 0
    && selectableInvoices.every((invoice) => selectedInvoices.includes(invoice.id));
  const someSelectableSelected = selectableInvoices.some((invoice) => selectedInvoices.includes(invoice.id));

  const handleClientView = (clientId: number) => {
    navigate(`/clients/${clientId}`);
  };

  const handleContractView = (contractId: number | undefined) => {
    if (contractId) {
      navigate(`/contracts/${contractId}`);
    }
  };

  // Conteúdo principal (tabela)
  const desktopContent = (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: (theme) => theme.shadows[1],
        '& .MuiTable-root': {
          minWidth: 650,
        },
      }}
    >
      <Table size="small" stickyHeader>

        <TableHead>
          <TableRow
            sx={{
              '& .MuiTableCell-head': {
                bgcolor: (t) => `color-mix(in srgb, ${faturasColor} 12%, ${t.palette.background.paper})`,
                fontWeight: 700,
                fontSize: '0.73rem',
                py: 0.8,
                borderBottom: `2px solid ${alpha(faturasColor, 0.2)}`,
              },
            }}
          >
            <TableCell padding="checkbox">
              <Checkbox
                size="small"
                indeterminate={someSelectableSelected && !allSelectableSelected}
                checked={allSelectableSelected}
                disabled={selectableInvoices.length === 0}
                onChange={() => {
                  if (onSelectInvoice) {
                    if (allSelectableSelected) {
                      selectableInvoices.forEach((invoice) => {
                        onSelectInvoice(invoice.id, false);
                      });
                    } else {
                      selectableInvoices.forEach((invoice) => {
                        onSelectInvoice(invoice.id, true);
                      });
                    }
                  }
                }}
              />
            </TableCell>
            <TableCell>ID</TableCell>
            {showClientColumn && <TableCell>Cliente</TableCell>}
            {showContractColumn && <TableCell>Contrato</TableCell>}
            <TableCell>Tipo</TableCell>
            <TableCell>Vencimento</TableCell>
            <TableCell>Valor</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Pagamento</TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>Valor Pago</TableCell>
            {showGatewayColumn && <TableCell>Gateway</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            Array.from({ length: 8 }).map((_, i) => (
              <TableRow key={i}>
                <TableCell colSpan={12} align="center"><Skeleton /></TableCell>
              </TableRow>
            ))
          ) : error ? (
            <TableRow>
              <TableCell colSpan={showContractColumn ? 12 : 11} align="center">
                <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>
              </TableCell>
            </TableRow>
          ) : invoices.length === 0 ? (
            <TableRow>
              <TableCell colSpan={showContractColumn ? 12 : 11} align="center" sx={{ py: 4 }}>
                <Typography variant="body2" color="text.secondary">Nenhuma fatura encontrada</Typography>
              </TableCell>
            </TableRow>
          ) : (
            invoices.map((invoice) => (
              <TableRow onClick={() => handleOpenActionsModal(invoice)} key={invoice.id} hover sx={{ cursor: 'pointer', '&:hover': { bgcolor: alpha(faturasColor, 0.03) } }}>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedInvoices.includes(invoice.id)}
                    disabled={!isInvoiceSelectable(invoice)}
                    size="small"
                    onChange={(e) => { if (onSelectInvoice) onSelectInvoice(invoice.id, e.target.checked); }}
                    onClick={(e) => e.stopPropagation()}
                  />
                </TableCell>
                <TableCell sx={{ py: 0.5, fontSize: '0.78rem' }}>
                  <Typography variant="body2" fontWeight="bold" color="primary" sx={{ fontSize: '0.78rem', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleViewInvoice(invoice.id); }}>
                    #{invoice.id}
                  </Typography>
                </TableCell>
                {showClientColumn && (
                  <TableCell sx={{ whiteSpace: 'nowrap', py: 0.5, fontSize: '0.78rem' }}>
                    <Typography
                      variant="body2"
                      color="primary"
                      fontWeight="medium"
                      sx={{ fontSize: '0.78rem', cursor: 'pointer', whiteSpace: 'nowrap' }}
                      onClick={(e) => { e.stopPropagation(); handleClientView(invoice.cliente_id); }}
                    >
                      {invoice.cliente?.nome || `#${invoice.cliente_id}`}
                    </Typography>
                  </TableCell>
                )}
                {showContractColumn && (
                  <TableCell sx={{ whiteSpace: 'nowrap', py: 0.5, fontSize: '0.78rem' }}>
                    <Typography
                      variant="body2"
                      color={invoice.contrato_id ? "secondary" : "text.secondary"}
                      sx={{ fontSize: '0.78rem', cursor: 'pointer' }}
                      onClick={(e) => { e.stopPropagation(); handleContractView(invoice.contrato_id); }}
                    >
                      {invoice.contrato?.titulo || 'Geral'}
                    </Typography>
                  </TableCell>
                )}
                <TableCell sx={{ py: 0.5, fontSize: '0.78rem' }}>{invoiceService.formatType(invoice.tipo)}</TableCell>
                <TableCell sx={{ py: 0.5, fontSize: '0.78rem' }}>
                  <Typography
                    variant="body2"
                    color={invoiceService.isOverdue(invoice.data_vencimento, invoice.status) ? 'error' : 'text.primary'}
                    sx={{ fontSize: '0.78rem' }}
                  >
                    {formatarData(invoice.data_vencimento)}
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: 0.5, fontSize: '0.78rem', fontWeight: 600 }}>{formatarValor(calculateTotal(invoice))}</TableCell>
                <TableCell sx={{ py: 0.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <InvoiceStatusChip status={invoice.status} />
                    {invoice.cobranca_id && (
                      <Tooltip title={`Cobrança #${invoice.cobranca_id} vinculada — clique para abrir`}>
                        <IconButton
                          size="small"
                          color="warning"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedCobrancaIdForModal(invoice.cobranca_id!);
                            setGerenciarCobrancaOpen(true);
                          }}
                          sx={{ p: 0.2, '& .MuiSvgIcon-root': { fontSize: '1rem' } }}
                        >
                          <PriorityHighIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </TableCell>
                <TableCell sx={{ py: 0.5, fontSize: '0.78rem' }}>
                  {invoice.data_pagamento ? formatarData(invoice.data_pagamento) : '-'}
                </TableCell>
                <TableCell sx={{ py: 0.5, fontSize: '0.78rem', fontWeight: 600 }}>
                  {formatarValor((invoice as any).valor_pago || 0)}
                </TableCell>
                {showGatewayColumn && <TableCell sx={{ py: 0.5, fontSize: '0.78rem' }}>{invoice.gateway?.nome || '-'}</TableCell>}
              </TableRow>
            ))
          )}
        </TableBody>
        {!loading && invoices.length > 0 && (
          <TableFooter sx={{ position: 'sticky', bottom: 0, zIndex: 2, bgcolor: 'background.paper' }}>
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  bgcolor: (t) => `color-mix(in srgb, ${faturasColor} 15%, ${t.palette.background.paper})`,
                  fontWeight: 800,
                  fontSize: '0.78rem',
                  borderTop: `2px solid ${alpha(faturasColor, 0.3)}`,
                  py: 1.2,
                  color: 'text.primary',
                },
              }}
            >
              <TableCell colSpan={showClientColumn && showContractColumn ? 7 : showClientColumn || showContractColumn ? 5 : 4} align="right" sx={{ letterSpacing: '0.05em' }}>
                TOTAL DA PÁGINA
              </TableCell>
              <TableCell>
                {formatarValor(totalValorPagina)}
              </TableCell>
              <TableCell colSpan={2} />
              <TableCell>
                {formatarValor(totalPagoPagina)}
              </TableCell>
              {showGatewayColumn && <TableCell />}
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );

  const actionBtnSx = {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.2,
    aspectRatio: '1 / 1',
    p: 0.5,
    borderRadius: 1,
    justifyContent: 'center',
    textAlign: 'center',
    '& .MuiSvgIcon-root': { fontSize: '1.3rem' },
    '& .MuiTypography-root': { fontSize: '0.75rem', lineHeight: 1.1 }
  };

  // Modais compartilhados (renderizados para ambas as plataformas)
  const sharedModals = (
    <>
      {selectedInvoice && (
        <ProcessBoletoModal
          open={processBoletoOpen}
          onClose={handleProcessBoletoClose}
          invoice={selectedInvoice}
          onSuccess={() => {
            handleProcessBoleto(selectedInvoice);
          }}
        />
      )}

      {/* Modal de Visualização */}
      {viewInvoice && (
        <InvoiceViewModal
          open={viewModalOpen}
          onClose={handleCloseViewModal}
          invoice_id={viewInvoice.id}
          onInvoiceUpdated={onInvoiceUpdated}
          //onEdit={handleEditClick}
          onReceivePayment={handlePaymentFromView}
          onPrintSingleInvoiceWithSweet={handlePrintSingleInvoiceWithSweet}
          //onCancelInvoice={handleMassCancel}
          onEmitirNfcom={handleEmitirNfcomClick}
          onProcessBoleto={(invoice) => {
            handleCloseViewModal();
            handleProcessBoletoClick(invoice);
          }}
        />
      )}

      {/* Formulário de Edição de Fatura */}
      {selectedInvoiceForEdit && (
        <InvoiceEditForm
          open={editFormOpen}
          onClose={handleEditClose}
          onSubmit={handleEditSave}
          invoice={selectedInvoiceForEdit}
          title="Editar Fatura"
        />
      )}

      {/* Modal de Emissão NFCom */}
      <EmitirNfcomModal
        open={emitirNfcomOpen}
        onClose={handleEmitirNfcomClose}
        faturaId={selectedInvoiceForNfcom?.id ?? null}
        onSuccess={onInvoiceUpdated}
      />

      {/* Modal de Recibo */}
      {selectedInvoiceForRecibo && (
        <ReciboModal
          open={reciboOpen}
          onClose={handleReciboClose}
          invoiceId={selectedInvoiceForRecibo}
        />
      )}

      {/* Modal de Gerenciar Cobrança */}
      <GerenciarCobrancaModal
        open={gerenciarCobrancaOpen}
        onClose={() => setGerenciarCobrancaOpen(false)}
        cobrancaId={selectedCobrancaIdForModal}
        onSuccess={() => {
          if (onInvoiceUpdated) onInvoiceUpdated();
        }}
      />

      {/* Modal de Enviar Fatura */}
      {invoiceForEnviar && (
        <EnviarInvoiceModal
          open={enviarModalOpen}
          onClose={handleEnviarClose}
          invoiceId={invoiceForEnviar.id}
          clientId={invoiceForEnviar.cliente_id}
        />
      )}

      {/* Modal de Ações da Fatura */}
      <Dialog open={actionsModalOpen} onClose={handleCloseActionsModal} maxWidth="xs" fullWidth>
        <DialogTitle>Ações da Fatura {invoiceForActions ? `#${invoiceForActions.id}` : ''}</DialogTitle>
        <DialogContent sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(70px, 1fr))', gap: 0.5, p: 1 }}>
          {invoiceForActions && (
            <>
              <Button variant="outlined" onClick={() => { handleViewInvoice(invoiceForActions.id); handleCloseActionsModal(); }} sx={actionBtnSx}>
                <VisibilityIcon />
                <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Visualizar</Typography>
              </Button>
              <Button variant="outlined" onClick={() => { handleEnviarClick(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                <SendIcon />
                <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Enviar</Typography>
              </Button>
              {invoiceForActions.status !== 'pago' && invoiceForActions.status !== 'cancelado' && invoiceForActions.status !== 'parcialmente_pago' && (
                <Button variant="outlined" onClick={() => { handleEditClick(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <EditIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Editar</Typography>
                </Button>
              )}
              {invoiceForActions.status !== 'pago' && invoiceForActions.status !== 'cancelado' && (
                <Button variant="outlined" onClick={() => { handleReceivePaymentClick(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <PaymentIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Receber Pagamento</Typography>
                </Button>
              )}
              {invoiceForActions.status !== 'cancelado' && (
                <Button variant="outlined" onClick={() => { handlePrintSingleInvoiceWithSweet(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <PrintIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Imprimir Fatura</Typography>
                </Button>
              )}

              {invoiceForActions.status !== 'cancelado' && invoiceForActions.status !== 'pago' && invoiceForActions.status !== 'parcialmente_pago' && onRenegociar && (
                <Button variant="outlined" onClick={() => { onRenegociar([invoiceForActions.id]); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <RenegociarIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Renegociar</Typography>
                </Button>
              )}
              {invoiceForActions.gateway_id && invoiceForActions.gateway_id_externo && (
                <Button variant="outlined" onClick={() => { handleCheckGatewayStatus(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <SyncIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Checar Status</Typography>
                </Button>
              )}
              {canProcessBoleto(invoiceForActions) && invoiceForActions.gateway_id_externo === null && (
                <Button variant="outlined" onClick={() => { handleProcessBoletoClick(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <ReceiptIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Processar Boleto</Typography>
                </Button>
              )}
              {invoiceForActions.status !== 'cancelado' && invoiceForActions.nfcom_id === null && (
                <Button variant="outlined" onClick={() => { handleEmitirNfcomClick(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <ReceiptLongIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Emitir NFCom</Typography>
                </Button>
              )}
              {(invoiceForActions.status === 'aberto' || invoiceForActions.status === 'vencido') && (
                <Button variant="outlined" onClick={() => { handleMassCancel([invoiceForActions.id]); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <CancelIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Cancelar Fatura</Typography>
                </Button>
              )}
              {invoiceForActions.status === 'pago' && (
                <Button variant="outlined" onClick={() => { handleReciboClick(invoiceForActions); handleCloseActionsModal(); }} sx={actionBtnSx}>
                  <ReceiptIcon />
                  <Typography variant="caption" sx={{ lineHeight: 1.2, fontWeight: 'medium', textTransform: 'none' }}>Recibo</Typography>
                </Button>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseActionsModal}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </>
  );

  // Estrutura final com renderização condicional
  return (
    <>
      {desktopContent}
      {sharedModals}
    </>
  );
};

export default InvoicesTable; 